import type { CustomCellRendererProps } from "ag-grid-react";

import { ApplicationDeadlineControlBadge } from "../../../components/application/application-deadline-control-badge";
import { getApplicationDeadlineControlDisplay, type ApplicationsTableItem } from "../applications-page.lib";

export const ApplicationDeadlineControlCell = ({ data }: CustomCellRendererProps<ApplicationsTableItem>) => {
  const deadlineControl = getApplicationDeadlineControlDisplay(data);

  if (!deadlineControl) {
    return <span className="text-type-minor">—</span>;
  }

  return <ApplicationDeadlineControlBadge state={deadlineControl.state} label={deadlineControl.label} />;
};
